<template>
    <div id="view-blog-post">
        <div class="blog-post-preview-wrap">
            <div class="blog-post-preview-title">
                {{ blogpost.title }}
            </div>
            <div class="blog-post-preview-image">
                <img :src="blogpost.image | optimizeBlog" alt="">
            </div>
            <div id="blog-post-preview-body">
            </div>
        </div>
    </div>
  
</template>

<script>


export default {
    props: ['blogpost'],
    mounted: function() {
        document.getElementById("blog-post-preview-body").innerHTML = this.blogpost.body
    },
    filters: {
        optimizeBlog: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_1050/')
            return newUrl
        }
    }
}

</script>

<style>
#view-blog-post  {
    width:100%;
    height:100%;
}
.blog-post-preview-wrap {
    width:90%;
    margin-left:50px;
    margin-top:50px;
    margin-bottom: 50px;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
    box-shadow: 0 2px 5px 0px rgba(0,0,0,0.1);
    background-color: white;
}
.blog-post-preview-title {
    /* padding-top: 10px; */
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 34px;
    font-weight: bold;
}
.blog-post-preview-image {
    width: 100%;
}
.blog-post-preview-image img {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
}
#blog-post-preview-body{
    padding:0 20px;
    margin-top: 20px;
    padding-bottom: 20px;
    text-align: left;
}
#blog-post-preview-body > * {
    font-size: 22px;
}
</style>